<template>
<!--    <router-view  v-if="!check && !showLogo && isConnected"/>-->
  <router-view/>

  <div v-if="check && !showLogo && isConnected" class="blur"></div>
  <div dir="rtl" class="modal__error slide-top" v-if="check && !showLogo && isConnected"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p> توجه </p>
      <p>ℹ️</p>
    </div>
    <div>
      <div class="bg-white p-3 w-100 rounded">
        <p>
          تغییرات جدید اضافه شدن!
        </p>
      </div>
      <button @click="submitChange">بروزرسانی</button>
    </div>
  </div>

  <!--  <div class="card shadow"  style="position:fixed; bottom: 0; height: 3vw; left: 0; width: 80%;background-color: #ECEDED;border-radius: unset !important;">
      <p style="font-size: 0.9vw;transform: translateY(0.9vw);color: #777;"> 1403 © کلیه حقوق سامانه بهفام می محفوظ می باشد.

      </p>
    </div>-->

  <BackIcon v-if="$route.name !== 'home' && $route.name !== 'login'"/>
<!--  <HomeWaiting v-if="showLogo"/>-->
  <HomeWaitingTryagain v-if="!isConnected && !showLogo"/>
</template>
<script>
import {useToast} from "vue-toastification";
import BackIcon from "@/components/Icons/BackIcon.vue";
import HomeWaiting from "@/components/Loaders/HomeWaiting.vue";
import HomeWaitingTryagain from "@/components/Loaders/HomeWaitingTryagain.vue";

const toast = useToast();

export default {
  components: {HomeWaitingTryagain, HomeWaiting, BackIcon},
  data() {
    return {
      check: false,
      showLogo: true, // حالت اولیه نمایش لوگو
      isConnected: true, // حالت اولیه نمایش لوگو
    }
  },

  methods: {
    change() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ChangesFronts`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.check) {
              this.check = response.check;
              document.body.style.overflowY = 'hidden';
            }
          })
          .catch(() => {
            console.error("Error fetching changes.");
          });
    },
    submitChange() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ChangesFronts/store_change`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              this.check = false;
              if ('caches' in window) {
                caches.keys().then(function (names) {
                  for (let name of names)
                    caches.delete(name);
                });
              } else {
              }
              window.location.reload(true);
            }
            this.showLogo = false;
          })
          .catch(() => {
            console.error("Error submitting changes.");
          });
    },
    checkServerConnection() {
      fetch(`${this.base_url}/health-check`, {method: 'GET'})
          .then(response => {
            if (response.ok) {
              this.isConnected = true;
            } else {
              throw new Error('Failed to connect');
            }
          })
          .catch(() => {
            this.isConnected = false;
            toast.error("ارتباط با سرور برقرار نشد.");
          })
          .finally(() => {
            if (this.isConnected) {
              setTimeout(() => {
                this.showLogo = false;
              }, 3000);
            } else {
              this.showLogo = false; // مخفی کردن لوگو در صورت قطع ارتباط
            }
          });
    }
  },
  created() {
    this.change();
    this.checkServerConnection();
  }
}
</script>


<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  direction: rtl !important;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.modal__error {
  width: 30vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.3vw;
  padding: 1.1vw;
  box-shadow: 0 0 3px 2px #eee;
  background-color: #eceded;
  border: 0.1vw solid;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > p {

      font-size: 1.1vw;

      &:nth-child(2) {
        cursor: pointer;
      }

    }
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 1.1vw;


    }

    & > button {
      font-size: 1vw;
      width: 8vw;
      background-color: #3742FA;
      color: #fff;
      border: unset;
      border-radius: .5vw;
      height: 2vw;
      margin-top: 2.5vw;
      margin-bottom: 2.5vw;
      cursor: pointer;


    }
  }
}

.blur {
  background-color: rgba(#222, 0.8);
  width: 100%;
  z-index: 9999999999 !important;
  height: 100vh;
  position: absolute;
  top: 0;
}

* {
  user-select: text !important;
}
</style>
